import MenuItemOptionSimple from './MenuItemOptionSimple'

export default MenuItemOptionSimple
